<template>
  <v-card class="modal-principal">
    <v-card-title class="titulo">
      <span>{{ titulo }}</span>
      <v-spacer></v-spacer>
      <v-chip
        v-if="
          itemSeleccionado && itemSeleccionado.padre && itemSeleccionado.padre.numero_comprobante
        "
        color="grey lighten-3"
        text-color="primary"
      >Nro. Padre: {{ itemSeleccionado.padre.numero_comprobante }}</v-chip>
      <v-btn
        small
        icon
        v-if="puedoEditar() && itemSeleccionado.estado_facturacion.codigo === 'abierto'"
        @click="editar()"
        class="ma-0"
      >
        <v-icon
          small
          color="blue-grey"
        >edit</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-spinner v-if="cargando"></v-spinner>
    <v-card-text
      style="max-height: 100%;"
      v-else
    >
      <v-alert
        v-model="alerta.mostrar"
        dismissible
        :type="alerta.tipo"
      >
        {{ alerta.mensaje }}
      </v-alert>

      <v-container grid-list-md>
        <v-layout
          row
          wrap
        >
          <v-flex xs12>
            <v-autocomplete
              v-model="itemSeleccionado.institucion_id"
              :items="info.instituciones"
              :item-text="this.$options.filters.nombreCentro"
              item-value="id"
              label="Centro"
              @change="alCambiarInstitucion"
              v-validate="{ required: campoRequerido('institucion_id') }"
              :data-vv-name="'institucion_id'"
              :error-messages="errors.collect('institucion_id')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('institucion_id')"
            ></v-autocomplete>
          </v-flex>

          <v-flex
            xs12
            sm2
          >
            <v-autocomplete
              v-model="itemSeleccionado.punto_venta_id"
              :items="info.puntosVentas"
              item-text="numero"
              item-value="id"
              label="Punto de vta."
              @change="alCambiarPuntoVenta"
              v-validate="{ required: campoRequerido('punto_venta_id') }"
              :data-vv-name="'punto_venta_id'"
              :error-messages="errors.collect('punto_venta_id')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('punto_venta_id')"
            ></v-autocomplete>
          </v-flex>

          <v-flex
            xs12
            sm8
          >
            <v-autocomplete
              v-model="itemSeleccionado.tipo_comprobante_id"
              :items="info.tiposComprobantes"
              item-text="comprobante.nombre"
              item-value="comprobante.id"
              label="Tipo comprobante"
              @change="alCambiarTipoComprobante"
              v-validate="{ required: campoRequerido('tipo_comprobante_id') }"
              :data-vv-name="'tipo_comprobante_id'"
              :error-messages="errors.collect('tipo_comprobante_id')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('tipo_comprobante_id')"
            ></v-autocomplete>
          </v-flex>

          <v-flex
            xs12
            sm2
          >
            <v-autocomplete
              v-model="itemSeleccionado.tipo_comprobante_categoria_id"
              :items="info.categoriasTipoComprobantes"
              item-text="nombre"
              item-value="id"
              label="Letra"
              v-validate="{ required: campoRequerido('tipo_comprobante_categoria_id') }"
              :data-vv-name="'tipo_comprobante_categoria_id'"
              :error-messages="errors.collect('tipo_comprobante_categoria_id')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('tipo_comprobante_categoria_id')"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12>
            <v-autocomplete
              v-model="itemSeleccionado.tipo_receptor_id"
              :items="info.comprobanteReceptores"
              :item-text="nombreReceptor"
              item-value="tipo_id"
              label="Receptor"
              @change="alCambiarReceptor"
              v-validate="{ required: campoRequerido('tipo_receptor_id') }"
              :data-vv-name="'tipo_receptor_id'"
              :error-messages="errors.collect('tipo_receptor_id')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('tipo_receptor_id')"
            ></v-autocomplete>
          </v-flex>

          <v-flex
            xs12
            sm4
          >
            <v-text-field
              v-model="itemSeleccionado.numero_comprobante"
              label="Número"
              v-validate="{ required: campoRequerido('numero_comprobante') }"
              :data-vv-name="'numero_comprobante'"
              :error-messages="errors.collect('numero_comprobante')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('numero_comprobante')"
            ></v-text-field>
          </v-flex>

          <!--v-flex xs12 sm3>
            <v-text-field
              type="date"
              v-model="itemSeleccionado.fecha_prefactura"
              label="Fecha prefactura"
              v-validate="{ required: campoRequerido('fecha_prefactura') }"
              :data-vv-name="'fecha_prefactura'"
              :error-messages="errors.collect('fecha_prefactura')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('fecha_prefactura')"
            ></v-text-field>
          </v-flex-->

          <v-flex
            xs12
            sm4
          >
            <v-text-field
              type="date"
              v-model="itemSeleccionado.fecha"
              label="Fecha"
              v-validate="{ required: campoRequerido('fecha') }"
              :data-vv-name="'fecha'"
              :error-messages="errors.collect('fecha')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('fecha')"
              @change="alCambiarFecha()"
            ></v-text-field>
          </v-flex>

          <v-flex
            xs12
            sm4
          >
            <v-text-field
              type="date"
              v-model="itemSeleccionado.fecha_vencimiento"
              label="Fecha Vto."
              v-validate="{ required: campoRequerido('fecha_vencimiento') }"
              :data-vv-name="'fecha_vencimiento'"
              :error-messages="errors.collect('fecha_vencimiento')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('fecha_vencimiento')"
            ></v-text-field>
          </v-flex>

          <v-flex
            xs12
            sm4
          >
            <v-text-field
              type="number"
              prefix="$"
              v-model="itemSeleccionado.importe_facturado"
              label="Importe"
              v-validate="{ required: campoRequerido('importe_facturado'), min_value: valorMinimo('importe_facturado') }"
              :data-vv-name="'importe_facturado'"
              :error-messages="errors.collect('importe_facturado')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('importe_facturado')"
              :hint="$options.filters.currency(itemSeleccionado.importe_facturado)"
              persistent-hint
            ></v-text-field>
          </v-flex>

          <v-flex
            xs12
            sm4
          >
            <v-autocomplete
              v-model="itemSeleccionado.periodo_mes"
              :items="info.periodosMeses"
              item-text="nombre"
              item-value="id"
              label="Período Mes"
              v-validate="{ required: campoRequerido('periodo_mes') }"
              :data-vv-name="'periodo_mes'"
              :error-messages="errors.collect('periodo_mes')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('periodo_mes')"
            ></v-autocomplete>
          </v-flex>

          <v-flex
            xs12
            sm4
          >
            <v-autocomplete
              v-model="itemSeleccionado.periodo_ano"
              :items="info.periodosAnios"
              item-text="nombre"
              item-value="id"
              label="Período Año"
              v-validate="{ required: campoRequerido('periodo_ano') }"
              :data-vv-name="'periodo_ano'"
              :error-messages="errors.collect('periodo_ano')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('periodo_ano')"
            ></v-autocomplete>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              v-model="itemSeleccionado.concepto_descripcion"
              label="Concepto"
              v-validate="{ required: campoRequerido('concepto_descripcion') }"
              :data-vv-name="'concepto_descripcion'"
              :error-messages="errors.collect('concepto_descripcion')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('concepto_descripcion')"
            ></v-textarea>
          </v-flex>
        </v-layout>

        <v-layout
          row
          wrap
          v-if="mostrarCriterios"
        >
          <v-flex xs12>
            <v-subheader xs12>Criterios para facturar</v-subheader>
          </v-flex>

          <v-flex
            xs12
            sm4
          >
            <v-autocomplete
              v-model="itemSeleccionado.criterios.obra_social_id"
              :items="obrasSociales"
              item-text="nombre"
              item-value="id"
              label="Obra Social"
              v-validate="{ required: true }"
              data-vv-name="criterios.obra_social_id"
              data-vv-validate-on="blur"
              :error-messages="errors.collect('criterios.obra_social_id')"
              @change="alCambiarCriterio('obra_social_id')"
              :disabled="soloLectura"
            ></v-autocomplete>
          </v-flex>
          <template v-if="codigoTipoComprobanteSeleccionado === 'FCT'">
            <v-flex
              xs12
              sm4
            >
              <v-autocomplete
                v-model="itemSeleccionado.criterios.obra_social_plan_id"
                :items="obraSocialPlanes"
                item-text="nombre"
                item-value="id"
                label="Plan"
                v-validate="{ required: true }"
                data-vv-name="criterios.obra_social_plan_id"
                data-vv-validate-on="blur"
                :error-messages="errors.collect('criterios.obra_social_plan_id')"
                @change="alCambiarCriterio('obra_social_plan_id')"
                :disabled="soloLectura"
              ></v-autocomplete>
            </v-flex>
            <v-flex
              xs12
              sm4
            >
              <v-autocomplete
                v-model="itemSeleccionado.criterios.obra_social_plan_facturable_id"
                :items="facturables"
                item-text="nombre"
                item-value="id"
                label="Prestación a Facturar"
                v-validate="{ required: true }"
                data-vv-name="criterios.obra_social_plan_facturable_id"
                data-vv-validate-on="blur"
                :error-messages="errors.collect('criterios.obra_social_plan_facturable_id')"
                :disabled="soloLectura"
              ></v-autocomplete>
            </v-flex>
          </template>
        </v-layout>
        <v-layout
          row
          wrap
          v-if="facturaPrestacionPami"
        >
          <v-flex
            xs12
            sm4
          >
            <v-autocomplete
              v-model="itemSeleccionado.criterios.tipo_tratamientos"
              :items="info.tiposTratamientos"
              multiple
              item-text="nombre"
              item-value="id"
              label="Tipo tratamiento"
              v-validate="{ required: true }"
              :error-messages="errors.collect('criterios.tipo_tratamientos')"
              :data-vv-name="'criterios.tipo_tratamientos'"
              data-vv-validate-on="blur"
              :disabled="soloLectura"
            >
              <v-list-tile
                slot="prepend-item"
                ripple
                @click="selDesTipoTratamientos"
              >
                <v-list-tile-action>
                  <v-icon :color="
                      itemSeleccionado.criterios.tipo_tratamientos.length > 0 ? 'indigo darken-4' : ''
                    ">{{ iconoSeleccionarTodosLosTipoTratamientos }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-title>Todos</v-list-tile-title>
              </v-list-tile>
            </v-autocomplete>
          </v-flex>

          <!--v-flex
            xs12
            sm4
          >
            <v-autocomplete
              v-model="itemSeleccionado.criterios.facturar_solo_pendientes"
              :items="info.valoresSiNo"
              item-text="nombre"
              item-value="valor"
              label="Facturar todo lo pendiente"
              v-validate="{ required: true }"
              :error-messages="errors.collect('criterios.facturar_solo_pendientes')"
              :data-vv-name="'criterios.facturar_solo_pendientes'"
              data-vv-validate-on="none"
              @change="alCambiarCriterio('facturar_solo_pendientes')"
              :disabled="soloLectura"
            ></v-autocomplete>
          </v-flex-->
          <v-flex
            xs12
            sm2
          >
            <v-autocomplete
              v-model="itemSeleccionado.criterios.periodo_mes"
              :items="info.periodosMeses"
              item-text="nombre"
              item-value="id"
              label="Período Mes"
              v-validate="{ required: campoRequerido('criterios.periodo_mes') }"
              :data-vv-name="'criterios.periodo_mes'"
              :error-messages="errors.collect('criterios.periodo_mes')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('criterios.periodo_mes')"
            ></v-autocomplete>
          </v-flex>

          <v-flex
            xs12
            sm2
          >
            <v-autocomplete
              v-model="itemSeleccionado.criterios.periodo_ano"
              :items="info.periodosAnios"
              item-text="nombre"
              item-value="id"
              label="Período Año"
              v-validate="{ required: campoRequerido('criterios.periodo_ano') }"
              :data-vv-name="'criterios.periodo_ano'"
              :error-messages="errors.collect('criterios.periodo_ano')"
              data-vv-validate-on="blur"
              :disabled="campoDisabled('criterios.periodo_ano')"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <botones-cancelar-guardar
        v-bind:mostrar-guardar="puedo(operacion) && !soloLectura"
        v-bind:guardando="guardando"
        v-on:alGuardar="guardar"
        v-on:alCancelar="cerrar"
      ></botones-cancelar-guardar>
    </v-card-actions>
  </v-card>
</template>

<script>
import Combo from '@/api/combo'
import abmFormularioMixin from '@/mixins/abmFormulario'
import moment from 'moment'
import _ from 'lodash'
import { fechaFutura } from '@/helpers/filtros'
export default {
  name: 'FacturacionCentroFormulario',
  mixins: [abmFormularioMixin],
  computed: {
    mostrarCriterios () {
      return (
        this.tipoComprobanteSeleccionado && this.puntoVentaSeleccionado && this.receptorSeleccionado
      )
    },
    codigoTipoComprobanteSeleccionado () {
      return this.tipoComprobanteSeleccionado ? this.tipoComprobanteSeleccionado.codigo : null
    },
    codigoReceptorSeleccionado () {
      return this.receptorSeleccionado ? this.receptorSeleccionado.codigo : null
    },

    facturaPrestacionOtros () {
      return (
        this.codigoTipoComprobanteSeleccionado === 'FCT' &&
        this.codigoReceptorSeleccionado !== '900'
      )
    },
    facturaPrestacionPami () {
      return (
        this.codigoTipoComprobanteSeleccionado === 'FCT' &&
        this.codigoReceptorSeleccionado === '900'
      )
    },

    obraSocialPlanes () {
      if (this.obrasSociales.length > 0) {
        let obraSocialSeleccionada = _.find(this.obrasSociales, {
          id: this.itemSeleccionado.criterios.obra_social_id
        })
        return obraSocialSeleccionada ? obraSocialSeleccionada.planes : []
      } else {
        return []
      }
    },
    facturables () {
      if (this.obraSocialPlanes.length > 0) {
        let obraSocialPlanSeleccionado = _.find(this.obraSocialPlanes, {
          id: this.itemSeleccionado.criterios.obra_social_plan_id
        })
        return obraSocialPlanSeleccionado ? obraSocialPlanSeleccionado.facturables : []
      } else {
        return []
      }
    },
    obrasSociales () {
      return _.filter(this.info.comprobanteReceptores, item => {
        return item.tipo === 'O'
      })
    },
    iconoSeleccionarTodosLosTipoTratamientos () {
      if (
        this.itemSeleccionado.criterios.tipo_tratamientos.length ===
        this.info.tiposTratamientos.length
      ) {
        return 'mdi-close-box'
      }
      if (
        this.itemSeleccionado.criterios.tipo_tratamientos.length > 0 &&
        !(
          this.itemSeleccionado.criterios.tipo_tratamientos.length ===
          this.info.tiposTratamientos.length
        )
      ) {
        return 'mdi-minus-box'
      }
      return 'mdi-checkbox-blank-outline'
    }
  },
  data () {
    return {
      prefacturando: false,
      montarMixin: false,
      info: {
        instituciones: [],
        tiposComprobantes: [],
        puntosVentas: [],
        comprobanteReceptores: [],
        categoriasTipoComprobantes: [],
        periodosAnios: [],
        periodosMeses: [],
        facturables: [],
        valoresSiNo: [
          { valor: true, nombre: 'Si' },
          { valor: false, nombre: 'No' }
        ]
      },
      institucionSeleccionada: null,
      puntoVentaSeleccionado: null,
      tipoComprobanteSeleccionado: null,
      receptorSeleccionado: null,
      criterios: {
        id: 0,
        instituciones: [],
        tipo_tratamientos: [],
        obra_social_id: null,
        obra_social_plan_id: null,
        obra_social_plan_facturable_id: null,
        fecha_desde: null,
        fecha_hasta: null,
        periodo_mes: null,
        periodo_ano: null,
        facturar_solo_pendientes: false,
        punto_venta_id: null,
        numero_comprobante: null
      }
    }
  },
  mounted () {
    let vm = this

    if (vm.item.id > 0) {
      vm.modeloApi.obtener(vm.item.id).then(data => {
        if (!data.criterios) {
          data.criterios = _.cloneDeep(vm.criterios)
        }
        let tipoTratamientosIds = []

        _.map(data.criterios.tipo_tratamientos, item => {
          tipoTratamientosIds.push(item.tipo_tratamiento_id)
        })
        data.criterios.tipo_tratamientos = tipoTratamientosIds

        data.origen = 'centro'
        // data.importe_facturado = data.importe_facturado.replace('.', ',')
        // data.importe_prefacturado = data.importe_prefacturado.replace('.', ',')
        vm.itemSeleccionado = _.cloneDeep(data)

        vm.cargarInfo()
      })
    } else {
      let mesActual = parseInt(moment().format('M'))
      let anioActual = parseInt(moment().format('Y'))
      vm.item.criterios = vm.criterios

      vm.item.criterios.periodo_mes = mesActual === 1 ? 12 : mesActual - 1
      vm.item.criterios.periodo_ano = mesActual === 1 ? anioActual - 1 : anioActual
      vm.itemSeleccionado = _.cloneDeep(vm.item)
      vm.cargarInfo()
    }
  },
  methods: {
    cargarInfo () {
      let vm = this

      let cargaOrigen = 'inicial'

      let dataCombos = {
        instituciones: {
          itemVacio: 'Seleccione',
          soloHijos: true,
          asignados: true,
          relaciones: ['obrasSociales.obraSocial', 'puntosVenta.comprobantes.comprobante']
        },
        grupoEntidades: {
          categoriasTipoComprobantes: {
            codigo: 'tipo_comprobante_categoria',
            excluirCodigos: ['x', 'ncf', 'ndf'],
            itemVacio: true
          },
          tiposTratamientos: {
            codigo: 'tipo_tratamiento',
            soloHojas: true
          }
        },
        periodosAnios: {
          itemVacio: 'Seleccione'
        },
        periodosMeses: {
          itemVacio: 'Seleccione'
        }
      }

      if (vm.itemSeleccionado.id > 0) {
        cargaOrigen = 'edicion'
        dataCombos.comprobanteReceptores = {
          id: vm.itemSeleccionado.institucion_id
        }
      }

      vm.cargarCombos(dataCombos, cargaOrigen)
    },

    alCambiarInstitucion () {
      let vm = this

      vm.itemSeleccionado.tipo_comprobante_id = null
      vm.itemSeleccionado.punto_venta_id = null
      vm.itemSeleccionado.tipo_receptor_id = null

      vm.receptorSeleccionado = null
      vm.institucionSeleccionada = null
      vm.tipoComprobanteSeleccionado = null

      if (vm.itemSeleccionado.institucion_id) {
        vm.cargarCombosPorInstitucion()

        vm.institucionSeleccionada = _.find(vm.info.instituciones, {
          id: vm.itemSeleccionado.institucion_id
        })
        vm.$set(
          vm.info,
          'puntosVentas',
          _.sortBy(vm.institucionSeleccionada.puntos_venta, [
            item => {
              return item.numero
            }
          ])
        )
        vm.$set(vm.info, 'tiposComprobantes', [])

        vm.puntoVentaSeleccionado = _.find(vm.institucionSeleccionada.puntos_venta, {
          principal: true
        })

        if (vm.puntoVentaSeleccionado) {
          vm.itemSeleccionado.punto_venta_id = vm.puntoVentaSeleccionado.id
          vm.alCambiarPuntoVenta()
        }
      }
    },

    alCambiarPuntoVenta () {
      let vm = this

      vm.itemSeleccionado.tipo_comprobante_id = null
      vm.tipoComprobanteSeleccionado = null

      if (vm.itemSeleccionado.punto_venta_id) {
        vm.puntoVentaSeleccionado = _.find(vm.institucionSeleccionada.puntos_venta, {
          id: vm.itemSeleccionado.punto_venta_id
        })

        vm.$set(
          vm.info,
          'tiposComprobantes',
          _.sortBy(vm.puntoVentaSeleccionado.comprobantes, [
            item => {
              return item.comprobante.nombre
            }
          ])
        )

        vm.tipoComprobanteSeleccionado = _.find(vm.puntoVentaSeleccionado.comprobantes, item => {
          return item.comprobante.codigo === 'FCT'
        })

        if (vm.tipoComprobanteSeleccionado) {
          // vm.tipoComprobanteSeleccionado = tipoComprobanteSeleccionado.comprobante
          vm.itemSeleccionado.tipo_comprobante_id = vm.tipoComprobanteSeleccionado.comprobante_id
          vm.alCambiarTipoComprobante()
        }
      }
    },

    alCambiarTipoComprobante () {
      let vm = this

      vm.tipoComprobanteSeleccionado = _.find(vm.puntoVentaSeleccionado.comprobantes, {
        comprobante_id: vm.itemSeleccionado.tipo_comprobante_id
      })

      if (vm.tipoComprobanteSeleccionado) {
        vm.tipoComprobanteSeleccionado = vm.tipoComprobanteSeleccionado.comprobante
        if (
          vm.tipoComprobanteSeleccionado.codigo !== 'NCT' &&
          vm.tipoComprobanteSeleccionado.codigo !== 'NDT'
        ) {
          vm.itemSeleccionado.es_directo = false
        }
      }
    },

    cargarCombosPorInstitucion () {
      let vm = this

      let dataCombos = {
        comprobanteReceptores: {
          id: vm.itemSeleccionado.institucion_id
        }
      }

      vm.cargarCombos(dataCombos)
    },

    alCambiarReceptor () {
      let vm = this
      vm.receptorSeleccionado = _.find(vm.info.comprobanteReceptores, {
        tipo_id: vm.itemSeleccionado.tipo_receptor_id
      })
      if (vm.receptorSeleccionado.tipo === 'O' && vm.itemSeleccionado.criterios) {
        vm.itemSeleccionado.criterios.obra_social_id = vm.receptorSeleccionado.id
      }
      if (vm.codigoReceptorSeleccionado === '900') {
        vm.itemSeleccionado.numero_comprobante = ''
        vm.itemSeleccionado.importe_facturado = 0
      }
      vm.errors.clear()
    },

    alCambiarCriterio (prop) {
      switch (prop) {
        case 'obra_social_id':
          this.itemSeleccionado.criterios.obra_social_plan_id = null
          this.itemSeleccionado.criterios.obra_social_plan_facturable_id = null
          break
        case 'obra_social_plan_id':
          this.itemSeleccionado.criterios.obra_social_plan_facturable_id = null
          break
        default:
          break
      }
    },

    cargarCombos (dataCombos, cargaOrigen) {
      let vm = this
      Combo.listado(dataCombos).then(
        data => {
          vm.info = _.assign(vm.info, data)

          switch (cargaOrigen) {
            case 'edicion':
              vm.itemSeleccionado.tipo_receptor_id = vm.itemSeleccionado.facturado_obra_social
                ? 'O_' + vm.itemSeleccionado.facturado_obra_social.id
                : 'I_' + vm.itemSeleccionado.facturado_institucion.id
              vm.institucionSeleccionada = _.find(vm.info.instituciones, {
                id: vm.itemSeleccionado.institucion_id
              })
              vm.puntoVentaSeleccionado = _.find(vm.institucionSeleccionada.puntos_venta, {
                id: vm.itemSeleccionado.punto_venta_id
              })
              vm.receptorSeleccionado = _.find(vm.info.comprobanteReceptores, {
                tipo_id: vm.itemSeleccionado.tipo_receptor_id
              })
              vm.tipoComprobanteSeleccionado = _.find(vm.puntoVentaSeleccionado.comprobantes, {
                comprobante_id: vm.itemSeleccionado.tipo_comprobante_id
              })
              vm.tipoComprobanteSeleccionado = vm.tipoComprobanteSeleccionado.comprobante

              vm.$set(vm.info, 'puntosVentas', vm.institucionSeleccionada.puntos_venta)
              vm.$set(vm.info, 'tiposComprobantes', vm.puntoVentaSeleccionado.comprobantes)
              break
            case 'inicial':
              vm.itemSeleccionado.institucion_id =
                vm.info.instituciones.length === 2 ? vm.info.instituciones[1].id : null
              if (vm.itemSeleccionado.institucion_id) {
                vm.alCambiarInstitucion()
              }

              break
          }

          vm.cargando = false
        },
        error => {
          vm.mostrarError(error)
          vm.cargando = false
        }
      )
    },

    nombreReceptor (item) {
      if (item.tipo === 'I') {
        return this.$options.filters.nombreCentro(item)
      } else {
        return item.nombre
      }
    },

    campoDisabled (campo) {
      let disabled = false
      switch (campo) {
        case 'numero_comprobante':
        case 'importe_facturado':
          disabled = this.facturaPrestacionPami
          break
        case 'fecha_prefactura':
          disabled = !this.facturaPrestacionPami
          break
        case 'criterios.periodo_mes':
        case 'criterios.periodo_ano':
          disabled = this.itemSeleccionado.criterios.facturar_solo_pendientes
          break
      }
      return this.soloLectura || disabled
    },

    campoRequerido (campo) {
      let requerido = true
      switch (campo) {
        case 'numero_comprobante':
          requerido = !this.facturaPrestacionPami
          break
        case 'fecha_prefactura':
          requerido = this.facturaPrestacionPami
          break
        case 'importe_facturado':
          requerido = !this.facturaPrestacion
          break
        case 'criterios.periodo_mes':
        case 'criterios.periodo_ano':
          requerido = !this.itemSeleccionado.criterios.facturar_solo_pendientes
          break
      }
      return !this.campoDisabled(campo) && requerido
    },

    valorMinimo (campo) {
      let valor = 0
      switch (campo) {
        case 'importe_facturado':
          valor = !this.campoRequerido(campo) ? 0 : 1
          break
      }
      return valor
    },

    alCambiarFecha () {
      if (this.itemSeleccionado.fecha) {
        this.itemSeleccionado.fecha_vencimiento = fechaFutura({ fecha: this.itemSeleccionado.fecha, cantidad: 30, formatoSalida: 'YYYY-MM-DD' })
      }
    },
    selDesTipoTratamientos () {
      this.$nextTick(() => {
        if (
          this.itemSeleccionado.criterios.tipo_tratamientos.length ===
          this.info.tiposTratamientos.length
        ) {
          this.itemSeleccionado.criterios.tipo_tratamientos = []
        } else {
          let tipoTratamientosIds = []
          _.map(this.info.tiposTratamientos, inst => {
            tipoTratamientosIds.push(inst.id)
          })
          this.itemSeleccionado.criterios.tipo_tratamientos = tipoTratamientosIds.slice()
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped></style>
